/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createLinkExpiredStyles = makeStyles(theme => ({
  root: {
    textAlign: 'center',
  },
  title: {
    fontSize: '48px',
    lineHeight: '48px',
    letterSpacing: '-0.32px',
    textAlign: 'center',
    margin: 0,
  },
  subTitle: {
    fontSize: '24px',
    lineHeight: '24px',
    letterSpacing: '-0.22px',
    color: theme.palette.text.primary,
    margin: '32px 0 0',
    fontWeight: 400,
  },
  linkContainer: {
    marginTop: '72px',
  },
  link: {
    textDecoration: 'none',
  },
}));
